
import IdleVue from "idle-vue";
import store from "~/store";
import Vue from "vue";

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000000, // 10 min
  startAtIdle: false
});